/**
 * Created by saeed on 1/31/2017.
 */
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({name: 'toPrice'})
export class ToPricePipe implements PipeTransform {
  transform(dateValue:number) {
    return this.makePriceFormat(dateValue);

  }

  makePriceFormat(price:number) {
    let pricestr = '0';
    if (price)
      pricestr = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    return this.toPersianDigits(pricestr) + " تومان";
  }

  toPersianDigits(number:string) {

    var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return number.replace(/[0-9]/g, function (w) {
      return id[+w]
    });
  }

}
@Pipe({name: 'pnumber'})
export class ToPersianNumberPipe implements PipeTransform {
  transform(dateValue:number) {
    if (dateValue)
      return this.toPersianDigits(dateValue.toString());
    else
      return '';

  }


  toPersianDigits(number:string) {
    if (number) {
      var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return number.replace(/[0-9]/g, function (w) {
        return id[+w]
      });
    }
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/price.pipe.ts